import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps {
  readonly tone?: BadgeTone;
  readonly children: ReactNode;
  readonly className?: string | undefined;
}

/**
 * Status-Pill im Editorial-Stil. Ersetzt die verstreuten Inline-Spans
 * (Cases-Statuslabels, Versions-History, Modul-Status) schrittweise.
 */
const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-stone-100 text-stone-700',
  success: 'bg-emerald-100 text-emerald-800',
  warning: 'bg-amber-100 text-amber-800',
  danger: 'bg-red-100 text-red-800',
  info: 'border border-stone-900 bg-white text-stone-900',
};

export function Badge({ tone = 'neutral', children, className }: BadgeProps) {
  const classes = [
    'inline-flex items-center rounded-sm px-2 py-0.5 font-sans text-[10px] font-medium uppercase tracking-widest',
    TONES[tone],
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <span className={classes}>{children}</span>;
}
